import { brave as enBrave, bravePreset as enPreset } from '../../../../../locales/en/member.json';
import {
  brave as twBrave,
  bravePreset as twPreset,
} from '../../../../../locales/zh-TW/member.json';
import {
  brave as cnBrave,
  bravePreset as cnPreset,
} from '../../../../../locales/zh-CN/member.json';
type Copy = typeof enBrave;
type Translator = (key: string, options: { defaultValue: string }) => string;
function localized<T extends Record<string, string>>(
  value: T,
  namespace: string,
  t?: Translator,
): T {
  if (!t) return value;
  return Object.fromEntries(
    Object.entries(value).map(([key, text]) => [
      key,
      t(namespace + '.' + key, { defaultValue: text }),
    ]),
  ) as T;
}
const dictionary = (language: string) =>
  /^(zh-CN|zh-Hans)/i.test(language)
    ? { brave: cnBrave, bravePreset: cnPreset }
    : /^zh/i.test(language)
      ? { brave: twBrave, bravePreset: twPreset }
      : { brave: enBrave, bravePreset: enPreset };
export const braveCopy = (language: string, t?: Translator): Copy =>
  localized(dictionary(language).brave, 'member:brave', t);
export const bravePresetCopy = (language: string, t?: Translator) =>
  localized(dictionary(language).bravePreset, 'member:bravePreset', t);
export const braveError = (code: string, c: Copy) =>
  /PREVIEW_CHANGED|VERSION_CHANGED|CONCURRENT_CHANGE/.test(code)
    ? c.stale
    : /FINALIZATION_BLOCKED/.test(code)
      ? c.blocked
      : /SOURCE_UNRESOLVED/.test(code)
        ? c.source
        : /REASON_REQUIRED/.test(code)
          ? c.reasonRequired
          : c.error;

export const braveCutoff = (value: string) =>
  `${new Date(new Date(value).getTime() + 28800000).toISOString().slice(0, 19).replace('T', ' ')} (Asia/Taipei)`;
